module.exports = __webpack_public_path__ + "img/commerce7-view-from-red-chirp.726d6538.png";